export interface MyPortfolioCapsulesSymbolDataAccumulatedValues {
    qty: number;
    qtyTraded: number;
    qtyRemaining: number;
    advPct?: number;
    averagePrice?: number;
}

export type MyPortfolioCapsulesSymbolDataAccumulatedColumn =
    keyof MyPortfolioCapsulesSymbolDataAccumulatedValues;

export interface MyPortfolioCapsulesSymbolDataDerivedValues {
    valueByOrderQty?: number;
    valueByTradedQty?: number;
    valueByRemainingQty?: number;
    arrivalPSlipWeightedByTradedValue?: number;
    arrivalPSlipAbsWeightedByTradedValue?: number;
    exCostWeightedByTradedValue?: number;
    exCostAbsWeightedByTradedValue?: number;
    movement?: number;
}

export interface MyPortfolioCapsulesSymbolDataWeights {
    tradedQtyWeightedByAveragePrice?: number;
}

export type MyPortfolioCapsulesSymbolDataWeightField =
    keyof MyPortfolioCapsulesSymbolDataWeights;

export interface MyPortfolioCapsulesSymbolDataTotalsState {
    accumulated: MyPortfolioCapsulesSymbolDataAccumulatedValues;
    weights: MyPortfolioCapsulesSymbolDataWeights;
    count: number;
}

export interface MyPortfolioCapsulesSymbolDataState
    extends MyPortfolioCapsulesSymbolDataTotalsState {
    derived: MyPortfolioCapsulesSymbolDataDerivedValues;
    weights: MyPortfolioCapsulesSymbolDataWeights;
}

export type MyPortfolioCapsulesDataStateAggregation = {
    totals: MyPortfolioCapsulesSymbolDataTotalsState;
    bySymbol: {
        [symbol: string]: MyPortfolioCapsulesSymbolDataState;
    };
};

export type AggregationKey = 'allValid' | 'excludingDone' | 'onlyDone';

export type MyPortfolioCapsulesDataState = {
    allValid: MyPortfolioCapsulesDataStateAggregation;
    excludingDone: MyPortfolioCapsulesDataStateAggregation;
    onlyDone: MyPortfolioCapsulesDataStateAggregation;
    reset: boolean;
};

export const initialMyPortfolioCapsulesSymbolDataState: () => MyPortfolioCapsulesSymbolDataState =
    () => ({
        count: 0,
        accumulated: { qty: 0, qtyTraded: 0, qtyRemaining: 0 },
        derived: {},
        weights: {},
    });

export const initialMyPortfolioCapsulesDataStateAggregation: () => MyPortfolioCapsulesDataStateAggregation =
    () => ({
        totals: { ...initialMyPortfolioCapsulesSymbolDataState() },
        bySymbol: {},
    });

export const initialMyPortfolioCapsulesDataState: () => MyPortfolioCapsulesDataState =
    () => ({
        reset: true,
        allValid: initialMyPortfolioCapsulesDataStateAggregation(),
        excludingDone: initialMyPortfolioCapsulesDataStateAggregation(),
        onlyDone: initialMyPortfolioCapsulesDataStateAggregation(),
    });
